// extracted by mini-css-extract-plugin
export var contentarea = "DogPage-module--contentarea--55760";
export var doginfosections = "DogPage-module--doginfosections--62423";
export var dogprofilebreed = "DogPage-module--dogprofilebreed--dfd9e";
export var mobileenquireorshare = "DogPage-module--mobileenquireorshare--376a2";